import { useSelector } from "react-redux"
import { selectLanguage } from "../features/language/languageSlice"

// Translation object
const translations = {
  ar: {
    cart: "السلة",
    noProducts: "لا توجد منتجات",
    loading: "جاري التحميل...",
    error: "حدث خطأ",
    retry: "إعادة المحاولة",
    addToCart: "أضف للسلة",
    checkout: "الدفع",
    total: "المجموع",
    quantity: "الكمية",
    price: "السعر",
    description: "الوصف",
    category: "الفئة",
    menu: "القائمة",
    home: "الرئيسية",
    settings: "الإعدادات",
    language: "اللغة",
    arabic: "العربية",
    english: "English",
    noName: "بدون اسم",
    close: "إغلاق",
    confirm: "تأكيد",
    cancel: "إلغاء",
    size: "الحجم",
    extras: "الإضافات",
    notes: "ملاحظات",
  },
  en: {
    cart: "Cart",
    noProducts: "No products available",
    loading: "Loading...",
    error: "An error occurred",
    retry: "Retry",
    addToCart: "Add to Cart",
    checkout: "Checkout",
    total: "Total",
    quantity: "Quantity",
    price: "Price",
    description: "Description",
    category: "Category",
    menu: "Menu",
    home: "Home",
    settings: "Settings",
    language: "Language",
    arabic: "العربية",
    english: "English",
    noName: "No Name",
    close: "Close",
    confirm: "Confirm",
    cancel: "Cancel",
    size: "Size",
    extras: "Extras",
    notes: "Notes",
  },
}

export const useReduxLanguage = () => {
  const language = useSelector(selectLanguage)

  const t = (key: string) => {
    const languageTranslations = translations[language] as Record<string, string>
    return languageTranslations?.[key] || key
  }

  const formatNum = (num: string | number) => {
    const numValue = typeof num === "string" ? Number.parseFloat(num) : num
    if (isNaN(numValue)) return "0"

    // Always format numbers in English regardless of language
    return numValue.toLocaleString("en-US")
  }

  return { t, language, formatNum }
}
